module.exports = __webpack_public_path__ + "img/caiji.e376b090.png";